/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.PaymentTransactionType_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.PaymentTransactionType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum PaymentTransactionType_ {
   /// <summary>
   ///   Void (V)
   /// </summary>
   Void = 0,
   /// <summary>
   ///   Refund (Cr)
   /// </summary>
   Credit = 1,
   /// <summary>
   ///   Charge (Dr)
   /// </summary>
   Sale = 2,
   /// <summary>
   ///   Returned Unpaid (Rtn)
   /// </summary>
   ReturnItem = 3,
   /// <summary>
   ///   Customer Chargeback (Cb)
   /// </summary>
   Chargeback = 4,
   /// <summary>
   ///   Inquiry (I)
   /// </summary>
   Inquiry = 5,
   /// <summary>
   ///   No Charge (Comp)
   /// </summary>
   Complimentary = 6,
   /// <summary>
   ///   Deposit (Dep)
   /// </summary>
   Deposit = 7,
   /// <summary>
   ///   Chargeback Reversed (CbR)
   /// </summary>
   ChargebackReversal = 8
}

export const PaymentTransactionTypes: PaymentTransactionType[] = [
   {
      code: PaymentTransactionType_.Void,
      literal: 'Void',
      description: 'Void',
      shortDescription: 'V',
      listPriority: 0,

      typeName: "PaymentTransactionType"
   },
   {
      code: PaymentTransactionType_.Credit,
      literal: 'Credit',
      description: 'Refund',
      shortDescription: 'Cr',
      listPriority: 0,

      typeName: "PaymentTransactionType"
   },
   {
      code: PaymentTransactionType_.Sale,
      literal: 'Sale',
      description: 'Charge',
      shortDescription: 'Dr',
      listPriority: 0,

      typeName: "PaymentTransactionType"
   },
   {
      code: PaymentTransactionType_.ReturnItem,
      literal: 'ReturnItem',
      description: 'Returned Unpaid',
      shortDescription: 'Rtn',
      listPriority: 0,

      typeName: "PaymentTransactionType"
   },
   {
      code: PaymentTransactionType_.Chargeback,
      literal: 'Chargeback',
      description: 'Customer Chargeback',
      shortDescription: 'Cb',
      listPriority: 0,

      typeName: "PaymentTransactionType"
   },
   {
      code: PaymentTransactionType_.Inquiry,
      literal: 'Inquiry',
      description: 'Inquiry',
      shortDescription: 'I',
      listPriority: 0,

      typeName: "PaymentTransactionType"
   },
   {
      code: PaymentTransactionType_.Complimentary,
      literal: 'Complimentary',
      description: 'No Charge',
      shortDescription: 'Comp',
      listPriority: 0,

      typeName: "PaymentTransactionType"
   },
   {
      code: PaymentTransactionType_.Deposit,
      literal: 'Deposit',
      description: 'Deposit',
      shortDescription: 'Dep',
      listPriority: 0,

      typeName: "PaymentTransactionType"
   },
   {
      code: PaymentTransactionType_.ChargebackReversal,
      literal: 'ChargebackReversal',
      description: 'Chargeback Reversed',
      shortDescription: 'CbR',
      listPriority: 0,

      typeName: "PaymentTransactionType"
   }
]

export class PaymentTransactionType implements IDomainModel {
   code: PaymentTransactionType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: PaymentTransactionType_): PaymentTransactionType {
      return PaymentTransactionTypes.find(d => d.code === code)
   }
}
